{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Kampanje live chata",
      "NEW_CAMPAIGN": "Stvori kampanju",
      "CARD": {
        "STATUS": {
          "ENABLED": "Omogućena",
          "DISABLED": "Onemogućena"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Pošiljatelj",
          "BOT": "Bot",
          "FROM": "od",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Nema dostupnih kampanja live chata",
        "SUBTITLE": "Povežite se s kupcima putem proaktivnih poruka. Kliknite 'Stvori kampanju' za početak."
      },
      "CREATE": {
        "TITLE": "Stvori kampanju live chata",
        "CANCEL_BUTTON_TEXT": "Odustani",
        "CREATE_BUTTON_TEXT": "Izradi",
        "FORM": {
          "TITLE": {
            "LABEL": "Naslov",
            "PLACEHOLDER": "Unesite naslov kampanje",
            "ERROR": "Naslov je obavezan"
          },
          "MESSAGE": {
            "LABEL": "Poruka",
            "PLACEHOLDER": "Unesite poruku kampanje",
            "ERROR": "Poruka je obavezna"
          },
          "INBOX": {
            "LABEL": "Odaberite sandučić",
            "PLACEHOLDER": "Odaberite sandučić",
            "ERROR": "Sandučić je obavezan"
          },
          "SENT_BY": {
            "LABEL": "Pošiljatelj",
            "PLACEHOLDER": "Odaberite pošiljatelja",
            "ERROR": "Pošiljatelj je obavezan"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Please enter the URL",
            "ERROR": "Please enter a valid URL",
            "URL_IS_REGEXP": "Vrijednost je regularni izraz"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Vrijeme na stranici (sekunde)",
            "PLACEHOLDER": "Unesite vrijeme",
            "ERROR": "Vrijeme na stranici je obavezno"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Ostale postavke",
            "ENABLED": "Omogući kampanju",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Pokreni samo tijekom radnog vremena"
          },
          "BUTTONS": {
            "CREATE": "Izradi",
            "CANCEL": "Odustani"
          },
          "API": {
            "SUCCESS_MESSAGE": "Kampanja live chata uspješno je stvorena",
            "ERROR_MESSAGE": "Došlo je do pogreške. Pokušajte ponovno."
          }
        }
      },
      "EDIT": {
        "TITLE": "Uredi kampanju live chata",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Kampanja live chata uspješno je ažurirana",
            "ERROR_MESSAGE": "Došlo je do pogreške. Pokušajte ponovno."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS kampanje",
      "NEW_CAMPAIGN": "Stvori kampanju",
      "EMPTY_STATE": {
        "TITLE": "Nema dostupnih SMS kampanja",
        "SUBTITLE": "Pokrenite SMS kampanju i izravno dođite do svojih kupaca. Jednostavno šaljite ponude ili obavijesti. Kliknite 'Stvori kampanju' za početak."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Završena",
          "SCHEDULED": "Zakazana"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Poslano iz",
          "ON": "dana"
        }
      },
      "CREATE": {
        "TITLE": "Stvori SMS kampanju",
        "CANCEL_BUTTON_TEXT": "Odustani",
        "CREATE_BUTTON_TEXT": "Izradi",
        "FORM": {
          "TITLE": {
            "LABEL": "Naslov",
            "PLACEHOLDER": "Unesite naslov kampanje",
            "ERROR": "Naslov je obavezan"
          },
          "MESSAGE": {
            "LABEL": "Poruka",
            "PLACEHOLDER": "Unesite poruku kampanje",
            "ERROR": "Poruka je obavezna"
          },
          "INBOX": {
            "LABEL": "Odaberite sandučić",
            "PLACEHOLDER": "Odaberite sandučić",
            "ERROR": "Sandučić je obavezan"
          },
          "AUDIENCE": {
            "LABEL": "Publika",
            "PLACEHOLDER": "Odaberite oznake kupaca",
            "ERROR": "Publika je obavezna"
          },
          "SCHEDULED_AT": {
            "LABEL": "Zakazano vrijeme",
            "PLACEHOLDER": "Odaberite vrijeme",
            "ERROR": "Zakazano vrijeme je obavezno"
          },
          "BUTTONS": {
            "CREATE": "Izradi",
            "CANCEL": "Odustani"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS kampanja uspješno je stvorena",
            "ERROR_MESSAGE": "Došlo je do pogreške. Pokušajte ponovno."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Jeste li sigurni da želite izbrisati?",
      "DESCRIPTION": "Brisanje je trajno i ne može se poništiti.",
      "CONFIRM": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Kampanja uspješno izbrisana",
        "ERROR_MESSAGE": "Došlo je do pogreške. Pokušajte ponovno."
      }
    }
  }
}
